import * as React from 'react';
import { useSelector } from 'react-redux';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { ApplicationState } from '../../../store';
import {
    AiSurveyOperationMetadata,
    DataCollectionAiAgentOperationType
} from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';
import { getActiveAIOperationFromState } from '../../../store/StateControllers/Survey/SurveyResponse/AISurveyAgentController';
import { useLocalizer } from './hooks/useLocalizer';

interface AIProcessingStatsProps {
    localizer?: IStringLocalizer;
    operationType?: DataCollectionAiAgentOperationType | null;
}

export const AIProcessingStats: React.FC<AIProcessingStatsProps> = ({
    localizer,
    operationType
}) => {
    const localize = useLocalizer(localizer);
    const aiOperation = useSelector((state: ApplicationState) =>
        getActiveAIOperationFromState(state.aiSurveyAgentState, operationType)
    );
    const metadata: AiSurveyOperationMetadata | null = aiOperation?.metadata ?? null;

    if (!metadata) {
        return null;
    }

    const highConfidence = metadata.highConfidenceAnswers ?? 0;
    const lowConfidence = metadata.lowConfidenceAnswers ?? 0;
    const insufficientData = metadata.insufficientDataAnswers ?? 0;

    return (
        <div className="ai-confidence-stats">
            <div className="ai-confidence-box ai-confidence-high">
                <span className="ai-confidence-value">{highConfidence}</span>
                <span className="ai-confidence-label">{localize("High Confidence")}</span>
            </div>
            <div className="ai-confidence-box ai-confidence-low">
                <span className="ai-confidence-value">{lowConfidence}</span>
                <span className="ai-confidence-label">{localize("Low Confidence")}</span>
            </div>
            <div className="ai-confidence-box ai-confidence-insufficient">
                <span className="ai-confidence-value">{insufficientData}</span>
                <span className="ai-confidence-label">{localize("Insufficient Data")}</span>
            </div>
        </div>
    );
};

export default AIProcessingStats;
